export default __webpack_public_path__ + "static/media/Rede Odontologia Final.65fb4a08.svg";